import type { PmTilesSourceId } from "./types";

function isPmTilesSourceId(sourceId: string): sourceId is PmTilesSourceId {
	return sourceId.startsWith("pmtiles__");
}

export { isPmTilesSourceId };
